import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { callIfChanged } from 'utilities/forms';

import { generateDistributionData } from 'store/scenes/distributions/actions';
import { getDistributionsFormValues } from 'store/form/distributions/selectors';

import NormalDistributionFieldsComponent from './Component';

class NormalDistributionFieldsContainer extends React.PureComponent {
  static propTypes = {
    generateDistributionData: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    const makeHandleChangeFn = property => callIfChanged((_, newValue) => {
      setTimeout(() => this.props.generateDistributionData({ [property]: newValue }));
    });

    this.handleMeanChange = makeHandleChangeFn('mean');
    this.handleStdevChange = makeHandleChangeFn('stdev');
  }

  render () {
    return (
      <NormalDistributionFieldsComponent
        onMeanChange={this.handleMeanChange}
        onStdevChange={this.handleStdevChange}
      />
    );
  }
}

const mapDispatchToProps = {
  generateDistributionData: values => (dispatch, getState) => {
    const distributionFormValues = getDistributionsFormValues(getState());
    dispatch(generateDistributionData({ ...distributionFormValues, ...values }));
  }
};

export default connect(null, mapDispatchToProps)(
  NormalDistributionFieldsContainer
);
